import { render } from "./holidays-modal.vue?vue&type=template&id=3ce2af55"
import script from "./holidays-modal.vue?vue&type=script&lang=js"
export * from "./holidays-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__